// extracted by mini-css-extract-plugin
export var actionHeader = "styles-module__actionHeader___lxwAF";
export var button = "styles-module__button___lG44d";
export var container = "styles-module__container___rxJkv";
export var ctaFooter = "styles-module__ctaFooter___IdEni";
export var fullWidth = "styles-module__fullWidth___bP66_";
export var scrollable = "styles-module__scrollable___hfnIi";
export var section = "styles-module__section___cazid";
export var title = "styles-module__title___SFEBn";